import { FormControl } from '@angular/forms';
import { ValidationService } from '../../../services/validation';
var ErrorMessagesComponent = /** @class */ (function () {
    function ErrorMessagesComponent() {
    }
    Object.defineProperty(ErrorMessagesComponent.prototype, "errorMessage", {
        get: function () {
            for (var propertyName in this.control.errors) {
                if ((this.control.errors.hasOwnProperty(propertyName) && this.control.touched)
                    || (this.control.pristine && this.submitted)) {
                    return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
                }
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return ErrorMessagesComponent;
}());
export { ErrorMessagesComponent };



// WEBPACK FOOTER //
// ./src/components/+utils/error_messages/error_messages.ts.pre-build-optimizer.js